import { Component } from 'angular-ts-decorators';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppComponent } from '@classes/app-component';
import { CookieStreams } from '@shared/app/scripts/services/cookie-streams';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { Domain } from '@shared/app/scripts/services/domain';
import { Intercom } from '@shared/app/scripts/services/intercom';
import { OsSniffer } from '@core/app/scripts/services/os-sniffer';
import { RouteParamsStreams } from '@core/app/scripts/services/route-params-streams';
import { Session } from '@shared/app/scripts/services/session';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { SidAutoRedirect } from '@core/app/scripts/services/sid-auto-redirect';

/**
 * Root component for gate app. Loads all necessary data & notify the user
 * about any possible issue.
 *
 * Inherits form {@link coreModule.AppComponent}.
 */
@Component({
  selector: 'gateApp',
  template: require('./gate-app.html').default,
})
export class GateAppComponent extends AppComponent {
  location: string;
  isLogged$: Observable<any>;
  showOldWindowsWarning: boolean;

  constructor(
    $element: ng.IAugmentedJQuery,
    $q: ng.IQService,
    $window: ng.IWindowService,
    cookieStreams: CookieStreams,
    currentSession: CurrentSession,
    domain: Domain,
    routeParamsStreams: RouteParamsStreams,
    session: Session,
    settingsManager: SettingsManager,
    sidAutoRedirect: SidAutoRedirect,
    // own dependencies
    private $rootScope: ng.IRootScopeService,
    private osSniffer: OsSniffer,
    $location: ng.ILocationService,
    intercom: Intercom,
  ) {
    'ngInject';

    super(
      $element,
      $window,
      routeParamsStreams,
      $q,
      cookieStreams,
      currentSession,
      domain,
      session,
      settingsManager,
      sidAutoRedirect,
    );

    this.$rootScope.$on('$routeChangeSuccess', () => {
      this.location = $location.url();
    });

    this.dependencies['intercom'] = intercom;
  }

  ngOnInit() {
    super.ngOnInit();

    this.isLogged$ = this.session.current$.pipe(
      map((currentSession: CurrentSession) => currentSession.isLogged),
    );

    this.showOldWindowsWarning = this.osSniffer.isUnsupportedWindows();
  }

  // hacky - overrides parent method, to inject optimistic promises
  // TODO cover with unit test
  getPromise(name): ng.IPromise<void> {
    return super.getPromise(name).catch(angular.noop);
  }
}
